import * as React from 'react';
const IconTelegram = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
    width={40}
    height={40}
  >
    <path
      fill="#08C"
      d="M34.75 1H7.25A6.25 6.25 0 0 0 1 7.25v27.5A6.25 6.25 0 0 0 7.25 41h27.5A6.25 6.25 0 0 0 41 34.75V7.25A6.25 6.25 0 0 0 34.75 1Z"
    />
    <path
      fill="#fff"
      d="M11.125 20.635c5.369-2.339 8.949-3.88 10.74-4.626 5.114-2.127 6.177-2.497 6.87-2.509.152-.002.493.035.713.214.186.152.238.356.262.5.025.142.055.469.031.724-.277 2.912-1.476 9.979-2.086 13.24-.259 1.38-.767 1.843-1.259 1.889-1.07.098-1.881-.707-2.917-1.386-1.621-1.063-2.537-1.724-4.11-2.761-1.819-1.198-.64-1.857.396-2.933.272-.282 4.984-4.568 5.075-4.956.011-.05.022-.23-.086-.326-.108-.096-.266-.063-.381-.037-.163.037-2.752 1.748-7.768 5.134-.735.505-1.4.751-1.997.738-.658-.014-1.923-.372-2.863-.677-1.153-.375-2.07-.573-1.99-1.21.041-.332.498-.67 1.37-1.018Z"
    />
    <path stroke="#F9E0F3" d="M.5.5h41v41H.5z" />
  </svg>
);
export default IconTelegram;
